import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageDynamic from './LegalPageDynamic.jsx';
import { getPublicContactEmail } from '../../../utils/publicContactEmail.js';

const CommerceFallback = ({ backTo = '/', backLabel = 'トップに戻る', embedded = false }) => {
  const currentYear = new Date().getFullYear();
  const lastUpdated = '2026年10月8日';
  const pageClassName = embedded ? 'hub-legal-page hub-legal-page--embedded' : 'hub-legal-page';

  return (
    <div className={pageClassName}>
      <div className="hub-legal-container">
        <div className="hub-legal-header">
          <Link to={backTo} className="hub-legal-back">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 20, height: 20 }}>
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            {backLabel}
          </Link>
          <h1>特定商取引法に基づく表記</h1>
          <p className="hub-legal-updated">最終更新日: {lastUpdated}</p>
        </div>

        <div className="hub-legal-content">
          <section>
            <h2>販売業者</h2>
            <p>株式会社ConvergePartners</p>
          </section>
          <section>
            <h2>代表責任者</h2>
            <p>登坂 悠也</p>
          </section>
          <section>
            <h2>所在地</h2>
            <p>〒330-0063 埼玉県さいたま市浦和区高砂一丁目2番1号 エイペックスタワー浦和108</p>
          </section>
          <section>
            <h2>電話番号</h2>
            <p>048-613-1887</p>
          </section>
          <section>
            <h2>メールアドレス</h2>
            <p>{getPublicContactEmail()}</p>
          </section>
          <section>
            <h2>ウェブサイト</h2>
            <p><a href="https://www.converge-p.co.jp" target="_blank" rel="noopener noreferrer">https://www.converge-p.co.jp</a></p>
          </section>
          <section>
            <h2>販売価格</h2>
            <p>各サービスの料金ページに表示された価格に準じます。</p>
          </section>
          <section>
            <h2>商品代金以外の必要料金</h2>
            <p>消費税、インターネット接続に必要な通信料等はお客様のご負担となります。</p>
          </section>
          <section>
            <h2>支払方法</h2>
            <p>クレジットカード決済（Visa, Mastercard, American Express, JCB）</p>
          </section>
          <section>
            <h2>支払時期</h2>
            <p>サービス利用開始時、およびその後は契約に基づく定期課金日。</p>
          </section>
          <section>
            <h2>商品の引き渡し時期</h2>
            <p>お申込み手続き完了後、直ちにサービスをご利用いただけます。</p>
          </section>
          <section>
            <h2>返品・キャンセル</h2>
            <p>デジタルサービスの性質上、サービス提供開始後の返品・返金は原則としてお受けしておりません。解約につきましてはサービス内の設定画面より手続きいただけます。</p>
          </section>
          <section>
            <h2>動作環境</h2>
            <p>最新のGoogle Chrome、Microsoft Edge、Safari、Firefoxを推奨いたします。インターネット接続環境が必要です。</p>
          </section>
        </div>

        <div className="hub-legal-footer">
          <p>&copy; {currentYear} Synapse by ConvergePartners Inc.</p>
        </div>
      </div>
    </div>
  );
};

const CommercePage = ({
  backTo = '/',
  backLabel = 'トップに戻る',
  embedded = false,
} = {}) => (
  <LegalPageDynamic
    docType="commerce"
    fallbackTitle="特定商取引法に基づく表記"
    backTo={backTo}
    backLabel={backLabel}
    embedded={embedded}
    fallbackContent={
      <CommerceFallback backTo={backTo} backLabel={backLabel} embedded={embedded} />
    }
  />
);

export default CommercePage;
